import type { Ref } from 'vue';

import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { PERMISSIONS_QUERY_KEY } from '@modules/permissions/constants';
import { useToastStore } from '@modules/toast/store';

import type { ISaveRolePermissionsPayload } from '../types';
import {
  ROLE_PERMISSIONS_QUERY,
  ROLES_PERMISSIONS,
  SAVE_ROLE_PERMISSIONS_API_URL,
  SAVE_ROLE_PERMISSIONS_MUTATION,
} from '../constants';

export default function useSaveRolePermissionsMutation(
  roleId: Ref<number | undefined>,
): IContextMutationResult<void, Error, ISaveRolePermissionsPayload> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, ISaveRolePermissionsPayload>({
    mutationKey: [SAVE_ROLE_PERMISSIONS_MUTATION],
    mutationFn: (payload) => fetchPost<void>(
      SAVE_ROLE_PERMISSIONS_API_URL,
      payload,
      {
        permission: ROLES_PERMISSIONS.ROLES_CREATE,
        urlParams: {
          roleId: roleId.value,
        },
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [ROLE_PERMISSIONS_QUERY] });
      await queryClient.invalidateQueries({ queryKey: [PERMISSIONS_QUERY_KEY] });

      displayPresetToast('edited');
    },
  });
}
